import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { SITE_NAME, IS_MRLOFT } from 'Config/config'

const baseUrl = 'https://8twelve.ca/myabode/application/'
const source = `${SITE_NAME}.ca`
const campaign = !IS_MRLOFT ? `${SITE_NAME}ca` : 'mrloft'
export const url = `${baseUrl}?utm_source=${source}&utm_medium=webapplication&utm_campaign=${campaign}preapproval`

const useHandleMortgageBrokerResponse = ({
  contactBrokerSuccess,
  contactBrokerFailure,
  contactBrokerMsg,
  buttonClicked,
  setButtonClicked,
  userIsAuthentificated,
}) => {
  // Store a reference to the pre-opened window
  const windowRef = useRef(null)

  // When the button is clicked, pre-open a blank tab immediately
  useEffect(() => {
    if(buttonClicked && userIsAuthentificated && !windowRef.current) {
      windowRef.current = window.open('about:blank', '_blank')
    }
  }, [buttonClicked, userIsAuthentificated])

  // When the backend call succeeds, navigate the pre-opened tab
  useEffect(() => {
    if(contactBrokerSuccess && buttonClicked && userIsAuthentificated) {
      if(windowRef.current) {
        windowRef.current.location.href = url
        windowRef.current = null // clear after use
      }
      setButtonClicked(false)
    }
  }, [contactBrokerSuccess, buttonClicked, userIsAuthentificated, setButtonClicked])


  // Handle failure
  useEffect(() => {
    if(contactBrokerFailure && buttonClicked) {
      toast.error(contactBrokerMsg)
      try {
        windowRef.current.close()
      } catch(err) {
        // Some browsers/extensions may still block it
        console.warn('Failed to close popup:', err) // eslint-disable-line
      } finally {
        windowRef.current = null
      }
      setButtonClicked(false)
    }
  }, [contactBrokerFailure, buttonClicked, contactBrokerMsg, setButtonClicked])
}

export default useHandleMortgageBrokerResponse
